import { combineReducers, configureStore } from "@reduxjs/toolkit";
import uiSlice from "./slices/ui";
import sentinelSlice from "./slices/sentinelSlices";
const rootReducer = combineReducers({
    "ui.AppLayout": uiSlice,
    "sentinel.General": sentinelSlice,
});
export const setupStore = (preloadedState?: Partial<RootState>) => 
    configureStore({
        reducer: rootReducer,
        preloadedState,
    });
export const store = configureStore({
    reducer: rootReducer,
});
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppStore = ReturnType<typeof setupStore>;
export const useUIStore = (state: RootState) => state["ui.AppLayout"];